import { useEffect } from "react";
import { useLoaderData, useActionData, Form } from "react-router-dom";
import { Button, Stack, styled, TextField, MenuItem } from "@mui/material";
import useInfoSnackbar from "../../lib/bandung/hooks/useInfoSnackbar";
import PageTitle from "../ui/PageTitle";
import FormHeader from "../ui/FormHeader";

const StyledStack = styled(Stack)`
  height: 100%;
  width: 100%;
  padding-top: 3em;
`;

const Delete = () => {
  const snackbarInfo = useInfoSnackbar(2000, "bottom", "right");
  const loaderData = useLoaderData();
  const conversations = loaderData.conversations || [];
  const actionData = useActionData();

  useEffect(() => {
    if (actionData) {
      if (actionData.code === "SUCCESS") {
        snackbarInfo.alertSuccess(actionData.message);
      } else {
        snackbarInfo.alertError(actionData.message);
      }
    }
  }, [actionData]);

  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          <PageTitle
            title="Delete Conversations"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Conversations", path: "/conversation" },
              { name: "Delete", path: "/conversation/delete" },
            ]}
          />
        </div>

        <div className="flex items-center justify-center h-[350px]">
          <div className="w-[600px] bg-white p-10 border-solid border-2 mt-8">
            <FormHeader title="Delete a Conversation" />
            <StyledStack>
              <Form method="post">
                <Stack
                  direction={"column"}
                  justifyContent={"space-between"}
                  spacing={2}
                  mb={2}
                >
                  <TextField
                    id="conversationEntityId"
                    name="conversationEntityId"
                    label="Select a Conversation Type to Delete"
                    fullWidth
                    select
                    required
                  >
                    {conversations.map((conversation) => (
                      <MenuItem
                        key={conversation.conversationEntityId}
                        value={conversation.conversationEntityId}
                      >
                        {conversation.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Stack>
                <Stack mt={2}>
                  <Button
                    type={"submit"}
                    variant={"outlined"}
                    sx={{
                      color: "#1e3faf",
                      borderRadius: "9999px",
                      borderColor: "#60a5fa",
                      "&:hover": {
                        backgroundColor: "#dbeafe",
                      },
                    }}
                  >
                    Delete
                  </Button>
                </Stack>
              </Form>
            </StyledStack>
          </div>
          </div>
      </div>
    </>
  );
};

export default Delete;
